import {
  Stack,
  Box,
  Container,
  Flex,
  Icon,
  Heading,
  Text,
  SimpleGrid,
  HStack,
} from "@chakra-ui/react";
import CombinedHeading from "../../common/CombinedHeading";
import {
  FiGlobe,
  FiZap,
  FiClock,
  FiShield
} from "react-icons/fi";
import { Link } from "react-router-dom";
import { linksConfig } from "../../../utils/CommonLinks";
const DedicatedSection = () => {
  return (
    <>
      <Stack as="div" bg={"#111"}>
        <Container
          maxW={"7xl"}
          pt={{ base: 10, md: 4 }}
          pb={{ base: 4, md: 4 }}
        >
          <Box
            as="div"
            color="brand.midGrey"
            fontSize={{ base: "xs", md: "md" }}
          >
            <CombinedHeading
              topHeading="Build with Confidence"
              mainHeading="Dedicated Nodes For gRPC Streams"
              subHeading="Upgrade to Dedicated gRPC nodes for large scale streaming requirements."
              isCenter={true}
            />
            <Box
              as="div"
              bg={"transparent"}
              borderRadius="2xl"
              py={12}
              px={{base: 8, md: 24}}
              border={"2px solid"}
              borderColor="brand.faintGrey"
              mt={14}
            >
              {/* <Heading as="h3" size="md" mb={6}>
                Enterprise-grade Dedicated Nodes
              </Heading> */}
              <SimpleGrid
                columns={{ base: 1, lg: 2 }}
                spacingX="24"
                spacingY="8"
                justifyContent={"space-evenly"}
              >
                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiGlobe} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Worldwide Availability
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      Our dedicated nodes are available in multiple locations
                      across Europe, the United States and South-east Asia.
                    </Text>
                  </Box>
                </HStack>

                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiZap} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Speed Boost
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      Experience lightning-fast streaming with updates directly from Solana leaders. 
                      Get upto 50ms advantage over shared gRPC by connecting directly to your node.
                    </Text>
                  </Box>
                </HStack>

                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiShield} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Zero Downtime
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      A robust pool of backup nodes guarantee uninterrupted service, 
                      even if anything happens to your node.
                    </Text>
                  </Box>
                </HStack>

                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiClock} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Priority Support
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      Top priority with direct communication channels with Shyft devs. Focus on the product, we have your back.
                    </Text>
                  </Box>
                </HStack>
              </SimpleGrid>
              <Box pt={8}>
                <Flex justifyContent={"center"}>
                  <Box>
                    <Link
                      as={"a"}
                      href={linksConfig.DISCORD_LINK}
                      _hover={{ textDecoration: "none" }}
                    >
                      <Box
                        width={{ base: "160px", md: "160px" }}
                        bg={"brand.red"}
                        color={"brand.white"}
                        rounded={"full"}
                        height={{ base: '40px', md: '40px' }}
                        py={{ base: "6px", md: "7px" }}
                        _hover={{
                          bg: "brand.white",
                          color: "brand.red",
                        }}
                        style={{
                          transition: "all 0.2s ease",
                        }}
                        textAlign={"center"}
                        fontFamily={"heading"}
                        fontWeight={500}
                        fontSize={{ base: "sm", md: "md" }}
                      >
                        Connect with us
                      </Box>
                    </Link>
                  </Box>
                </Flex>
              </Box>
            </Box>
          </Box>
        </Container>
      </Stack>
    </>
  );
};

export default DedicatedSection;